/**************************************************
 * Nombre:       Formulario_Contacto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, ApartmentOutlined, PhoneAndroidOutlined} from "@mui/icons-material";
import {NEGRITA} from "../../Constantes";

const Formulario_Informacion = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{boxShadow: 3, p: 3, backgroundColor: 'white', py: 6}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 0}}>
                    <Typography sx={{fontSize: 38, fontFamily: NEGRITA, fontWeight: 600, lineHeight: 1.1}}>SOLICITAR
                        Información</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: 2}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400}}>El egresado del programa Técnico Laboral en
                        Asistente Administrativo está preparado para apoyar de manera eficiente las áreas
                        administrativas, con</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombres'} dato={'nombres'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Celular'} dato={'celular'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={ApartmentOutlined} nombre={'Correo'} dato={'correo'} {...props}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Programa de Interes'} dato={'programa'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2, mb: 2}}>
                    <Button fullWidth sx={{color: '#fff'}}>Enviar Mensaje</Button>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Informacion